import WorldMap from './WorldMap';
import Charts from './Charts';

const MapChartGroup = () => {
	return (
		<div className='map-chart-group'>
			<WorldMap />
			<Charts />
		</div>
	)
}

export default MapChartGroup;